import React, {useState} from 'react';
import './DesktopLogin.css';
import Login from "../../Pages/Login/Login";
import {useNavigate} from "react-router-dom";

const DesktopLogin = () => {

    const navigate = useNavigate();

    const onLoginRedirect = () => {
        navigate("/reserve", {replace: true});
    }

    return (
        <div className={'desktop-login-page'}>
            <Login />
            <div className={'bg-pic-login-desktop'}></div>
        </div>
    );
};

export default DesktopLogin;